import React from "react";
import Reveal from "@/components/Reveal";
import { Facebook, Clock } from "lucide-react";
import { BAND } from "@/data/band";

function SpotifyIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.5 17.32a.75.75 0 01-1.03.25c-2.82-1.72-6.37-2.11-10.55-1.16a.75.75 0 11-.33-1.46c4.57-1.04 8.5-.59 11.66 1.34.36.22.47.69.25 1.03zm1.47-3.27a.94.94 0 01-1.29.31c-3.23-1.99-8.16-2.56-11.98-1.4a.94.94 0 11-.55-1.8c4.37-1.33 9.8-.69 13.51 1.59.44.27.58.85.31 1.3zm.13-3.4C15.32 8.3 8.75 8.08 4.99 9.22a1.13 1.13 0 11-.66-2.16c4.32-1.31 11.57-1.06 16.13 1.65a1.13 1.13 0 01-1.16 1.94z" />
    </svg>
  );
}
function AppleIcon(props) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M16.36 1.43c.04 1.06-.36 2.1-1.05 2.86-.74.82-1.94 1.45-3.04 1.36-.13-1.04.38-2.13 1.02-2.82.72-.79 1.97-1.38 3.07-1.4zM20.3 17.06c-.55 1.27-.82 1.84-1.53 2.97-1 1.58-2.41 3.54-4.15 3.55-1.55.02-1.95-1.01-4.05-1-2.1.01-2.54 1.02-4.09 1.01-1.74-.02-3.07-1.79-4.07-3.36-2.8-4.42-3.1-9.61-1.37-12.37 1.23-1.97 3.17-3.12 5-3.12 1.86 0 3.03 1.02 4.57 1.02 1.49 0 2.4-1.02 4.55-1.02 1.63 0 3.36.89 4.59 2.42-4.03 2.21-3.38 7.97.02 9.9z" />
    </svg>
  );
}

export default function Listen() {
  return (
    <section id="listen" data-testid="listen" className="relative py-24 md:py-32 bg-[#0a0a0b]">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 text-center">
        <Reveal>
          <span className="text-sm font-bold uppercase tracking-[0.25em] text-[var(--sb-red)]">Listen</span>
          <h2 className="font-display text-5xl md:text-7xl text-white mt-3">New Music On The Way</h2>
          <p className="text-white/65 mt-4 text-lg max-w-2xl mx-auto">
            Original tracks are in the works. Streaming links will land here the moment they're live —
            follow along so you don't miss the first drop.
          </p>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 grid sm:grid-cols-2 gap-4 max-w-2xl mx-auto">
            <div
              data-testid="streaming-spotify"
              className="relative rounded-2xl border border-white/10 bg-[#141416] p-6 flex items-center gap-4 opacity-90"
            >
              <SpotifyIcon className="w-10 h-10 text-[#1DB954] shrink-0" />
              <div className="text-left">
                <div className="text-white font-bold text-lg">Spotify</div>
                <div className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[var(--sb-amber)] mt-0.5">
                  <Clock size={12} /> Coming Soon
                </div>
              </div>
            </div>

            <div
              data-testid="streaming-apple"
              className="relative rounded-2xl border border-white/10 bg-[#141416] p-6 flex items-center gap-4 opacity-90"
            >
              <AppleIcon className="w-10 h-10 text-white shrink-0" />
              <div className="text-left">
                <div className="text-white font-bold text-lg">Apple Music</div>
                <div className="inline-flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[var(--sb-amber)] mt-0.5">
                  <Clock size={12} /> Coming Soon
                </div>
              </div>
            </div>
          </div>
        </Reveal>

        <Reveal delay={0.2}>
          <div className="mt-8">
            <p className="text-white/50 text-sm uppercase tracking-wider mb-4">In the meantime, follow the band</p>
            <a
              href={BAND.facebook}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="facebook-link"
              className="inline-flex items-center gap-3 bg-[#1877F2] hover:bg-[#0f63d6] text-white font-bold uppercase tracking-wider rounded-full px-7 h-14 transition-colors"
            >
              <Facebook size={20} /> Follow on Facebook
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
